import React, { Component } from 'react'
import { loadState } from './store/localStorage'
import { Provider } from 'react-redux'
import configureStore from './store/configureStore'
import UnifiedPageLayout from './routers/UnifiedPageLayout'
import './styles/main.scss'
import './styles/app.less'
import AuthService from './services/AuthService'
import GroupCreationGate from './components/auth/GroupCreationGate'

const persistedState = loadState()
const store = configureStore(persistedState)

class App extends Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
  }
  // componentDidMount() {
  //   const auth = new AuthService()
  //   auth.refreshToken()
  // }
  render () {
    return (
      <Provider store={store}>
        <>
          <UnifiedPageLayout />
          <GroupCreationGate />
        </>
      </Provider>
    )
  }
}

export default App
